<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <b-card :title="service_title" class="mr-1 ml-1">
      <b-row>
        <b-col>
          <p class="alert alert-warning p-2"><b>ATTENZIONE!</b> Esplora attentamente tutte le possibilità di scelta offerte dalla sezione "buoni", ma ricorda che una volta inviata la richiesta d'acquisto di un prodotto/buono specifico, essa non potrà essere annullata.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- Per il form usiamo gli attributi "classici" e non effettuamo il submit con axios perchè ci serve il target "blank" per il redirect -->
          <!-- Il campo di input non lo prendiamo da bootstrap vue perchè hidden non è supportato -->
          <b-form
              target="_blank"
              ref="sso_form"
              method="POST"
              :action="login_url"
          >
            <input type="hidden" name="d" :value="user_data">
            <b-form-group id="group-ok-condizioni">
              <b-form-checkbox
                  id="ok-condizioni"
                  name="ok-condizioni"
                  :value="true"
                  :unchecked-value="false"
                  v-model="conditions_checkbox"
                  required>
                <span class="font-italic">Confermo di voler accedere al portale {{service_title}} e di essere consapevole che i buoni opzionati non potranno essere annullati.</span>
              </b-form-checkbox>
            </b-form-group>
            <!-- Il submit viene effettuato dalla funzione execute_sso la quale fa poi comparire la pagina di redirect alla home -->
            <!-- non possiamo contrasegnare il pulsante come submit perchè se usiamo anche l'evento click questo impedisce il submit -->
            <!-- stesso evitando l'apertura della pagina di fano al centro. -->
            <b-button v-if="conditions_checkbox" variant="primary" @click="execute_sso">Accedi al portale {{service_title}}</b-button>
          </b-form>
        </b-col>
      </b-row>
      <!-- Uno slot per del contenuto addizionale sotto al form -->
      <slot name="form-footer"></slot>
    </b-card>
    <b-container fluid class="mt-2">
      <b-row>
        <b-col>
          <p>
            Solo con SaluteSemplice accedi ad oltre 250.000 prestazioni sanitarie disponibili in più di 6.000 strutture distribuite in tutta Italia.
            <br/>
            Tra i nostri servizi potrai trovare dalle visite specialistiche alle cure odontoiatriche e dagli esami di laboratorio fino alla medicina alternativa.
            <br/>
            Richiedi ora la tua prima prestazione!
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script >
import PageTagline from "@/components/PageTagline.vue";
import axios from "axios";
import {apiUrl} from "@/apiUrl";
import {generalLib} from "@/generalLib";

export default {
  name: "SaluteSempliceLoginPage",
  data(){
    return {
      tagline_elem : [ { text : "Salute Semplice", link : 'conv-salute-semplice' } ],
      service_title : "Salute Semplice",

      // Url di login e dati utente cifrati presi dal backend
      // sulla base della configurazione delle props.
      login_url : null,
      user_data : null,

      // Checkbox di conferma delle condizioni
      conditions_checkbox: false,
    }

  },
  methods: {
    execute_sso : function () {
      // Prendiamo il form ed invochiamo manualmente l'evento submit
      // per inviare i dati.
      let form = this.$refs.sso_form;
      form.submit();
      this.$router.replace( { name : 'conv-redirect', params:  { page_title : this.service_title } } );
    }
  },
  created () {
    /* Costruisco la stringa criptata con i dati utente e l'url di login */
    axios.post( apiUrl.welfareapi.create_acq_salute_semplice_login )
        .then( ( response ) => {
          this.user_data = response.data.enc_data;
          this.login_url = response.data.login_url;
        })
        .catch( ( error ) => {
          generalLib.backend_error_message_box( this, error.response.data );
        });
  },
  components: {
    PageTagline
  },

}
</script>

<style scoped>

</style>